import { createFileRoute } from "@tanstack/react-router";
import LegalCreate from "@/features/legal/components/LegalCreate";

export const Route = createFileRoute("/_protected/_legal/legal/create")({
  head: () => ({
    meta: [{ title: "Legal · Create" }],
  }),
  component: LegalCreate,
});
